import React from 'react';
import DatePicker from 'components/molecules/common/Form/DatePicker';
import { FormData } from './OptimizePlan';
import SelectWithInfiniteScroller from 'components/atoms/SelectWithInfiniteScroller';
import dayjs from 'dayjs';
interface IProps {
    setFormData: React.Dispatch<React.SetStateAction<FormData>>;
    formData: FormData;
}
const OptimizePlanForm: React.FC<IProps> = ({ setFormData, formData }) => {
    const optimizeOptions = [
        { label: 'Maximize Stat Volume', value: 'maximize_stat_volume', disabled: false },
        { label: 'Maximize Net Price $', value: 'maximize_net_price', disabled: false },
        { label: 'Maximize Net Price less MDF / stat', value: 'maximize_net_price_less_mdfsat', disabled: false },
        { label: 'Maximize TTL GP GM$', value: 'maximize_ttl_gp_gm', disabled: false },
        { label: 'Maximize Total Profit Pool', value: 'maximize_total_profit_pool', disabled: false },
        { label: 'Maximize Retailer $ Sales', value: 'maximize_retailer_sales', disabled: false },
        {
            label: 'Minimize Total Trade Spend Incl MDF ($s)',
            value: 'minimize_total_trade_spend_incl_mdf',
            disabled: false,
        },
        {
            label: 'Minimize Total Trade Spend Incl MDF (% of List)',
            value: 'minimize_total_trade_spend_incl_mdf_of_list',
            disabled: false,
        },
        {
            label: 'Minimize Total Working Investment  ($S) (Trade + MDF + ISM)',
            value: 'minimize_total_working_investment_trade_mdf_ism',
            disabled: false,
        },
        { label: 'Maximize Retailer Margin $s', value: 'retailer_margin', disabled: false },
        { label: 'Maximize Retailer Margin %', value: 'retailer_margin_percent', disabled: false },
    ];

    return (
        <div className="flex gap-4 px-2 py-3 bg-[rgba(250,250,250,1)] rounded-lg mb-3">
            <div className="flex flex-1 gap-4">
                <div className="text-right flex gap-1 items-center">
                    <>
                        {true && <span className="text-redTriangle">*</span>}
                        Objective:
                    </>
                </div>
                <SelectWithInfiniteScroller
                    hasMore={false}
                    showSearch={false}
                    filterOption={false}
                    placeholder={`Select Multiple...`}
                    maxTagCount="responsive"
                    className="dropdown-height !h-8 !w-48"
                    showArrow
                    onChange={(val) => {
                        setFormData((prev) => ({
                            ...prev,
                            objective: val,
                        }));
                    }}
                    value={formData.objective}
                    options={optimizeOptions}
                />
            </div>
            <DatePicker
                value={formData.start_date}
                label="Start Date"
                isRequired={true}
                onChange={(date: number | null) => {
                    setFormData((prev) => ({ ...prev, start_date: date }));
                }}
                format="MM/DD/YYYY"
                showToday={true}
                className="flex-1 !h-8 !w-48"
                enabledDates={{ start: dayjs().startOf('day').unix() }}
            />
        </div>
    );
};

export default React.memo(OptimizePlanForm);
